import React from "react";
import styled from "styled-components";
import LSRgBody01 from "../../molecules/text/linSeedKr/Rg/lsRgBody01";
import LSRgCaption02 from "../../molecules/text/linSeedKr/Rg/lsRgCaption02";
import { macOSCheck } from "../../../util/macOSCheck";

const Checkbox = ({
  isSmall,
  id,
  checked,
  name,
  valueText,
  required,
  value,
  onChange,
  style,
  textStyle,
}) => {
  return (
    <CheckboxLabel htmlFor={id} style={{ ...style }} checked={checked}>
      <CheckboxBoxIcon
        isSmall={isSmall}
        src={
          checked
            ? "/assets/icons/check_a_20.png"
            : "/assets/icons/check_d_20.png"
        }
        alt={checked ? "체크됨" : "체크되지 않음"}
      />
      {isSmall && (
        <LSRgCaption02
          style={{
            color: "#404249",
            height: "14px",
            marginTop: macOSCheck() ? 0 : 2,
            ...textStyle,
          }}
        >
          {valueText}
        </LSRgCaption02>
      )}

      {!isSmall && (
        <LSRgBody01 style={{ color: "#404249", height: "20px", ...textStyle }}>
          {valueText}
        </LSRgBody01>
      )}
      <CheckboxInput
        type="checkbox"
        required={required}
        value={value}
        name={name}
        id={id}
        checked={checked}
        onChange={onChange}
      />
    </CheckboxLabel>
  );
};

export default Checkbox;

const CheckboxLabel = styled.label.attrs((props) => {})`
  display: flex;
  align-items: center;
  height: ${(props) => (props.isSmall ? "14px" : "20px")};
  gap: 8px;
  cursor: pointer;
`;

const CheckboxBoxIcon = styled.img.attrs((props) => {})`
  width: ${(props) => (props.isSmall ? "14px" : "20px")};
  height: ${(props) => (props.isSmall ? "14px" : "20px")};
  object-fit: cover;
`;

const CheckboxInput = styled.input.attrs((props) => {})`
  display: none;
`;
